import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { Environment } from '@elight/client/shared/utility/common';

import { AuthService } from './auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService, private env: Environment) {}

    intercept(
        request: HttpRequest<unknown>,
        next: HttpHandler
    ): Observable<HttpEvent<unknown>> {
        if (request.url.indexOf(this.env.api.baseURL) >= 0) {
            return this.authService.getToken().pipe(
                switchMap((token) => {
                    if (!token) {
                        return next.handle(request);
                    }

                    const clonedRequest = request.clone({
                        setHeaders: {
                            Authorization: `Bearer ${token}`,
                        },
                    });

                    return next.handle(clonedRequest);
                })
            );
        }
        return next.handle(request);
    }
}
